export const asset_record = (type, title, subtitle = '', tone = 'teal') => ({ type, title, subtitle, tone });

export const asset_item = (title, subtitle, badge, badge_class, icon = 'bi-check2-square', tone = 'green') => ({
  title,
  subtitle,
  badge,
  badge_class,
  icon,
  tone
});

export const asset_status_class_map = {
  'In service': 'bg-success-subtle text-success-emphasis',
  'Maintenance due': 'bg-warning-subtle text-warning-emphasis',
  'Inspection overdue': 'bg-danger-subtle text-danger-emphasis',
  'Disposal due': 'bg-secondary-subtle text-secondary-emphasis'
};

export const asset_risk_class_map = {
  Low: 'bg-success-subtle text-success-emphasis',
  Medium: 'bg-warning-subtle text-warning-emphasis',
  High: 'bg-danger-subtle text-danger-emphasis',
  Critical: 'bg-danger-subtle text-danger-emphasis'
};

export const asset_risk_score_map = {
  Low: '32%',
  Medium: '53%',
  High: '88%',
  Critical: '91%'
};

export const disposal_status_class_map = {
  Identified: 'bg-secondary-subtle text-secondary-emphasis',
  'Pending approval': 'bg-warning-subtle text-warning-emphasis',
  'In progress': 'bg-warning-subtle text-warning-emphasis',
  Closed: 'bg-success-subtle text-success-emphasis'
};

export const create_asset_form = () => ({
  asset: '',
  category: 'IT',
  location: '',
  owner: '',
  serial: '',
  purchase_value: '',
  acquired: '',
  supplier: '',
  linked_contract: '',
  warranty_expiry: '',
  insurance: '',
  risk_rating: 'Low',
  compliance_status: 'In service',
  note: ''
});

export const create_disposal_form = () => ({
  ref: '',
  asset: '',
  reason: '',
  method: '',
  salvage_value: '',
  approval_route: '',
  stage: 'Identified',
  status: 'Identified',
  note: ''
});

export const asset_currency = (value) => {
  const numeric = Number(String(value || '').replace(/[^0-9.]/g, '')) || 0;
  if (!numeric) return 'R 0';
  return `R ${numeric.toLocaleString('en-ZA', { maximumFractionDigits: 0 })}`;
};

export const asset_tone_class = (tone) => {
  const tone_map = {
    teal: 'is-slate',
    green: 'is-green',
    orange: 'is-orange',
    red: 'is-red',
    danger: 'is-red',
    warning: 'is-orange',
    slate: 'is-slate'
  };
  return Reflect.get(tone_map, tone) || 'is-slate';
};

export const asset_icon_for_type = (type) => {
  const icon_map = {
    Facility: 'bi-building',
    Supplier: 'bi-truck',
    Contract: 'bi-file-earmark-text',
    Insurance: 'bi-shield-check',
    Continuity: 'bi-diagram-3',
    Security: 'bi-shield-lock',
    Incident: 'bi-exclamation-triangle',
    Expense: 'bi-cash-stack',
    HSE: 'bi-heart-pulse',
    Licence: 'bi-award',
    Control: 'bi-sliders',
    Route: 'bi-signpost'
  };
  return Reflect.get(icon_map, type) || 'bi-circle';
};
